import React, { memo } from "react";
import { useTranslation } from "react-i18next";
import submit from "submit-form";
import FilterChips from "../../../athlete-portal/calendar/FilterChips";

const SelectedExercises = ({
  selectedExercises,
  handleDeselect,
  deselectAll,
  isOnboarding = false,
  classNames = "",
}) => {
  const { t } = useTranslation("coaching-portal");
  const {
    squat,
    bench,
    deadlift,
    assistant,
    clean,
    jerk,
    snatch,
    overheadPress,
    other,
  } = selectedExercises;

  const handleSave = (e) => {
    e.preventDefault();
    submit("/actions/user/catalog-add-exercises", {
      method: "POST",
      body: { selectedExercises },
    });
  };

  const invalid =
    !squat.length &&
    !bench.length &&
    !deadlift.length &&
    !assistant.length &&
    !clean.length &&
    !jerk.length &&
    !snatch.length &&
    !overheadPress.length &&
    !other.length;

  const cat = (key) => t(`exerciseLibraryCatalog.categories.${key}`);

  return (
    <section className={classNames}>
      <header>
        <h3>
          {isOnboarding
            ? t("exerciseLibraryCatalog.yourExercises")
            : t("exerciseLibraryCatalog.selectedExercises")}
        </h3>
        <button
          data-button-type="secondary"
          onClick={deselectAll}
          disabled={invalid ? true : undefined}
        >
          {t("exerciseLibraryCatalog.clearAll")}
        </button>
      </header>

      <div className="selected-exercises-list">
        <fieldset>
          <legend>{t("exerciseLibraryCatalog.accessories")}</legend>
          <FilterChips
            filters={assistant.map((ex) => {
              return { text: ex.movement, id: ex._id };
            })}
            clearFilter={(id) =>
              handleDeselect(assistant.find((ex) => ex._id === id))
            }
          />
        </fieldset>
        <fieldset>
          <legend>{cat("squat")}</legend>
          <FilterChips
            filters={squat.map((ex) => {
              return { text: ex.movement, id: ex._id };
            })}
            clearFilter={(id) =>
              handleDeselect(squat.find((ex) => ex._id === id))
            }
          />
        </fieldset>
        <fieldset>
          <legend>{cat("benchPress")}</legend>
          <FilterChips
            filters={bench.map((ex) => {
              return { text: ex.movement, id: ex._id };
            })}
            clearFilter={(id) =>
              handleDeselect(bench.find((ex) => ex._id === id))
            }
          />
        </fieldset>
        <fieldset>
          <legend>{cat("deadlift")}</legend>
          <FilterChips
            filters={deadlift.map((ex) => {
              return { text: ex.movement, id: ex._id };
            })}
            clearFilter={(id) =>
              handleDeselect(deadlift.find((ex) => ex._id === id))
            }
          />
        </fieldset>
        <fieldset>
          <legend>{cat("clean")}</legend>
          <FilterChips
            filters={clean.map((ex) => {
              return { text: ex.movement, id: ex._id };
            })}
            clearFilter={(id) =>
              handleDeselect(clean.find((ex) => ex._id === id))
            }
          />
        </fieldset>
        <fieldset>
          <legend>{cat("jerk")}</legend>
          <FilterChips
            filters={jerk.map((ex) => {
              return { text: ex.movement, id: ex._id };
            })}
            clearFilter={(id) =>
              handleDeselect(jerk.find((ex) => ex._id === id))
            }
          />
        </fieldset>
        <fieldset>
          <legend>{cat("snatch")}</legend>
          <FilterChips
            filters={snatch.map((ex) => {
              return { text: ex.movement, id: ex._id };
            })}
            clearFilter={(id) =>
              handleDeselect(snatch.find((ex) => ex._id === id))
            }
          />
        </fieldset>
        <fieldset>
          <legend>{cat("overheadPress")}</legend>
          <FilterChips
            filters={overheadPress.map((ex) => {
              return { text: ex.movement, id: ex._id };
            })}
            clearFilter={(id) =>
              handleDeselect(overheadPress.find((ex) => ex._id === id))
            }
          />
        </fieldset>
        <fieldset>
          <legend>{cat("other")}</legend>
          <FilterChips
            filters={other.map((ex) => {
              return { text: ex.movement, id: ex._id };
            })}
            clearFilter={(id) =>
              handleDeselect(other.find((ex) => ex._id === id))
            }
          />
        </fieldset>
      </div>
      {!isOnboarding && (
        <button
          data-button-type="primary"
          disabled={invalid ? true : undefined}
          onClick={handleSave}
        >
          {t("exerciseLibraryCatalog.save")}
        </button>
      )}
    </section>
  );
};

export default memo(SelectedExercises);
